import * as v from 'valibot'

export type NormalMessageChatReplyPlannerSettingFormType = {
  message: string
  isEnabled: boolean
}

const validNormalMessageChatReplyPlannerSettingFormSchema = v.object({
  message: v.pipe(v.string(), v.trim(), v.nonEmpty('必須です')),
  isEnabled: v.boolean(),
})

export const validateNormalMessageChatReplyPlannerSettingForm = (
  form: NormalMessageChatReplyPlannerSettingFormType
) => {
  const result = v.safeParse(
    validNormalMessageChatReplyPlannerSettingFormSchema,
    form,
    { abortEarly: true }
  )

  if (result.success) {
    return undefined
  }

  const errors = v.flatten(result.issues).nested
  return {
    message: errors?.message,
    isEnabled: errors?.isEnabled,
  }
}
